// 存储该页面设置全局变量的字段

export const BEFORELOGININFO = 'beforeLoginInfo'

export const TOADDRESSBOOKLIST = 'toAddressBooklist'

export const TOSELECTADDRESS = 'toSelectAddress'
